module.exports = __webpack_public_path__ + "img/car-cabfind.cbc43bf9.png";